import React from 'react';
import { Provider } from 'mobx-react';
import { isMobile } from 'react-device-detect';
import { createBrowserHistory } from 'history';
import { syncHistoryWithStore } from 'mobx-react-router';
import { Router } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';

import * as stores from './stores';
import Routes from './routes';
import GlobalStyles from './styles/global';

import ExternalHTML from './components/ExternalHTML';
import MobileHeader from './components/MobileHeader';
import MobileFooter from './components/MobileFooter';
import ScrollToTop from './components/ScrollToTop';
import Faq from './containers/Faq';

import { importExternalScripts } from './utils/scripts';
import { axiosInteceptor } from './apis/six-api/axios/inteceptor';

smoothscroll.polyfill();
axiosInteceptor();

const browserHistory = createBrowserHistory();
const history = syncHistoryWithStore(browserHistory, stores.routerStore);

function App() {
  const tiaoURL = process.env.REACT_APP_TIAO_URL;
  const scripts = [`${tiaoURL}/dist/tiao.min.js`];

  importExternalScripts(scripts);

  return (
    <Provider {...stores}>
      <Router history={history}>
        <ScrollToTop>
          {isMobile ? <MobileHeader /> : <ExternalHTML component="header" />}
          <Routes />
          <Faq />
          {isMobile ? <MobileFooter /> : <ExternalHTML component="footer" />}
          <GlobalStyles />
        </ScrollToTop>
      </Router>
    </Provider>
  );
}

export default App;
